// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Application Detail Modal Styles
 * Clean, responsive styles matching UserDetailModal layout
 */

/* Modal Overlay - Now using global styles from design-system.css */

/* Modal Container - Now using global styles from design-system.css */

/* Modal Header - Now using global styles from design-system.css */

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-btn:hover:not(:disabled) {
  background: #e9ecef;
  color: #333;
}

.close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Modal Body - Now using global styles from design-system.css */

/* Form Sections */
.detail-section {
  margin-bottom: 24px;
}

.detail-section:last-of-type {
  margin-bottom: 0;
}

.detail-section h4 {
  margin: 0 0 16px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 2px solid #e9ecef;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.section-header h4 {
  margin: 0;
  border: none;
  padding: 0;
}

.status-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
}

.info-value {
  color: #2c3e50;
  font-size: 0.875rem;
  word-break: break-word;
}

.info-value a {
  color: #0D3B66;
  text-decoration: none;
}

.info-value a:hover {
  text-decoration: underline;
}

/* Executive Committee Information Styles */
.committee-member {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #0D3B66;
}

.committee-member:last-child {
  margin-bottom: 0;
}

.committee-member h5 {
  margin: 0 0 0.75rem 0;
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.committee-member h5::before {
  content: "👤";
  font-size: 0.875rem;
}

.contact-preferences {
  margin-top: 1rem;
  padding: 1rem;
  background: #e3f2fd;
  border-radius: 6px;
  border-left: 3px solid #0D3B66;
}

.contact-preferences h5 {
  margin: 0 0 0.75rem 0;
  color: #0D3B66;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.contact-preferences h5::before {
  content: "📞";
  font-size: 0.875rem;
}

/* Screening Information Styles */
.detail-section h4::before {
  content: "🎬";
  margin-right: 0.5rem;
}

/* Application Settings & Permissions Styles */
.settings-group {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #28a745;
}

.settings-group:last-child {
  margin-bottom: 0;
}

.settings-group h5 {
  margin: 0 0 0.75rem 0;
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.settings-group h5::before {
  content: "⚙️";
  font-size: 0.875rem;
}

.status-indicator {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-indicator.enabled {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-indicator.disabled {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Enhanced Section Headers */
.detail-section h4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Executive Committee Section */
.detail-section:has(.committee-member) h4::before {
  content: "👥";
}

/* Application Settings Section */
.detail-section:has(.settings-group) h4::before {
  content: "⚙️";
}

/* Modal Footer - Now using global styles from design-system.css */

/* Buttons - Now using global styles from design-system.css */

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c82333;
}

/* Responsive Design */
@media (min-width: 768px) {
  .info-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-container {
    max-height: 95vh;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-header h2 {
    font-size: 1.3rem;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-footer {
    padding: 12px 16px;
  }

  .detail-section {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/applications/ApplicationDetailModal.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mEAAmE;;AAEnE,qEAAqE;;AAErE,kEAAkE;;AAElE;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gEAAgE;;AAEhE,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,2CAA2C;AAC3C;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA,kEAAkE;;AAElE,6DAA6D;;AAE7D;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/**\n * Application Detail Modal Styles\n * Clean, responsive styles matching UserDetailModal layout\n */\n\n/* Modal Overlay - Now using global styles from design-system.css */\n\n/* Modal Container - Now using global styles from design-system.css */\n\n/* Modal Header - Now using global styles from design-system.css */\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover:not(:disabled) {\n  background: #e9ecef;\n  color: #333;\n}\n\n.close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Modal Body - Now using global styles from design-system.css */\n\n/* Form Sections */\n.detail-section {\n  margin-bottom: 24px;\n}\n\n.detail-section:last-of-type {\n  margin-bottom: 0;\n}\n\n.detail-section h4 {\n  margin: 0 0 16px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #333;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.section-header h4 {\n  margin: 0;\n  border: none;\n  padding: 0;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.info-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.875rem;\n}\n\n.info-value {\n  color: #2c3e50;\n  font-size: 0.875rem;\n  word-break: break-word;\n}\n\n.info-value a {\n  color: #0D3B66;\n  text-decoration: none;\n}\n\n.info-value a:hover {\n  text-decoration: underline;\n}\n\n/* Executive Committee Information Styles */\n.committee-member {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 3px solid #0D3B66;\n}\n\n.committee-member:last-child {\n  margin-bottom: 0;\n}\n\n.committee-member h5 {\n  margin: 0 0 0.75rem 0;\n  color: #2c3e50;\n  font-size: 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.committee-member h5::before {\n  content: \"👤\";\n  font-size: 0.875rem;\n}\n\n.contact-preferences {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #e3f2fd;\n  border-radius: 6px;\n  border-left: 3px solid #0D3B66;\n}\n\n.contact-preferences h5 {\n  margin: 0 0 0.75rem 0;\n  color: #0D3B66;\n  font-size: 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.contact-preferences h5::before {\n  content: \"📞\";\n  font-size: 0.875rem;\n}\n\n/* Screening Information Styles */\n.detail-section h4::before {\n  content: \"🎬\";\n  margin-right: 0.5rem;\n}\n\n/* Application Settings & Permissions Styles */\n.settings-group {\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border-left: 3px solid #28a745;\n}\n\n.settings-group:last-child {\n  margin-bottom: 0;\n}\n\n.settings-group h5 {\n  margin: 0 0 0.75rem 0;\n  color: #2c3e50;\n  font-size: 1rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.settings-group h5::before {\n  content: \"⚙️\";\n  font-size: 0.875rem;\n}\n\n.status-indicator {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-indicator.enabled {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.status-indicator.disabled {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Enhanced Section Headers */\n.detail-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Executive Committee Section */\n.detail-section:has(.committee-member) h4::before {\n  content: \"👥\";\n}\n\n/* Application Settings Section */\n.detail-section:has(.settings-group) h4::before {\n  content: \"⚙️\";\n}\n\n/* Modal Footer - Now using global styles from design-system.css */\n\n/* Buttons - Now using global styles from design-system.css */\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #c82333;\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .info-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .modal-container {\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header {\n    padding: 12px 16px;\n  }\n\n  .modal-body {\n    padding: 16px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n  }\n\n  .detail-section {\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
